<template>
  <div class="notification-panel">
    <div class="notification-panel-label notification-panel-form-group">Notification Panel</div>
    <div class="notification-panel-form-label">Templates</div>
    <table class="fts-table notification-panel-form-group">
      <thead>
        <tr>
          <th>ID</th>
          <th>Template</th>
          <th>Entry</th>
          <th>Target Date</th>
          <th>Target Time</th>
          <th>Status</th>
          <th>Remarks</th>
          <!-- <th>Preview</th>
          <th>Test</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="scheduledEvent in list" :key="scheduledEvent.id">
          <td>{{ scheduledEvent.id }}</td>
          <td>
            {{ getNotificationInformationDescription(scheduledEvent.templateId) }}
          </td>
          <td>{{ scheduledEvent.locusId }}</td>
          <td>{{ moment(scheduledEvent.targetDate).format('YYYY-MM-DD') }}</td>
          <td>{{ scheduledEvent.targetTime? moment(scheduledEvent.targetTime).format('YYYY-MM-DD h:ss A') : '-'  }}</td>
          <td>{{ automationStatusText(scheduledEvent.status) }}</td>
          <td>{{ scheduledEvent.remarks }}</td>
          <!-- <td><a href="" class="fts-text-primary" @click="preview(scheduleEvent)">Preview</a></td>
          <td><a href="" class="fts-text-primary" @click="test(scheduleEvent)">Test</a></td> -->
        </tr>
      </tbody>
    </table>

    <div class="notification-panel-form-label">Notification Delivery</div>
    <table class="fts-table notification-panel-form-group">
      <thead>
        <tr>
          <th>ID</th>
          <th>Entry ID</th>
          <th>Targets</th>
          <th>Channel</th>
          <th>Source</th>
          <th>Delivered on</th>
          <th>Status</th>
          <th>Remarks</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="delivery in notifications" :key="delivery.id">
          <td>{{ delivery.id }}</td>
          <td>{{ delivery.locusId }}</td>
          <td>{{ delivery.targets? delivery.targets.join(', ') : '-' }}</td>
          <td>{{ channelText(delivery.channel) }}</td>
          <td>{{ getNotificationInformationDescription(delivery.source) }}</td>
          <td>{{ delivery.deliveredOn? moment(delivery.deliveredOn).format('YYYY-MM-DD h:ss A') : '' }}</td>
          <td>{{ statusText(delivery.status) }}</td>
          <td>{{ delivery.remarks }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import { store } from "../store/canvasDesignStore";
import moment from "moment";

Vue.use(Vuex);

export default {
  props: {
    module: [String, Number],
  },
  store,
  data: () => ({
    list: [],
    notifications: [],
  }),
  methods: {
    moment,
    channelText(channel) {
      switch (channel) {
        case 0:
          return "Notification";
        case 1:
          return "Email";
        case 2:
          return "Slack";
        case 3:
          return "SMS";
        case 4:
          return "Whatsapp";
      }
    },
    statusText(status) {
      switch (status) {
        case 0:
          return "Pending";
        case 1:
          return "Delivered";
        case 2:
          return "Aborted";
        case 3:
      }
    },
    automationStatusText(status) {
      switch (status) {
        case 0:
          return "Pending";
        case 1:
          return "Executed";
        case 2:
          return "Aborted";
        case 3:
          return "Condition Met";
        case 4:
          return "No Recipient";
        case 5:
          return "Entity Changed";
      }
    },
    async loadNotificationDashboard() {
      let vm = this;
      let result = await this.$store.dispatch('loadNotifcationDashboard');
      vm.list = result.data.scheduledEvents;
      vm.notifications = result.data.notificationDeliveries;
    },
    async preview(scheduleEvent) {
      let response = await this.$store.dispatch("previewAutomation", {
        id: scheduleEvent.id,
      });
    },
    async test(scheduledEvent) {},
    getNotificationInformation(templateId) {
      var trigger = this.$store.state.vector.extension.triggers.find(
        (x) => x.id == templateId
      );
      return trigger;
    },
    getNotificationInformationDescription(templateId) {
      var trigger = this.$store.state.vector.extension.triggers.find(
        (x) => x.id == templateId
      );

      if (trigger && trigger.description) {
        return trigger.description;
      } else if (trigger) {
        var allElements = [];
        if (this.$store.state.vector.extension.information) {
          allElements = allElements.concat(this.$store.state.vector.extension.information);
        }

        if (this.$store.state.vector.extension.activities) {
          allElements = allElements.concat(this.$store.state.vector.extension.activities);
        }

        if (this.$store.state.vector.extension.states) {
          allElements = allElements.concat(this.$store.state.vector.extension.states);
        }

        if (this.$store.state.vector.extension.standardActivities) {
          allElements = allElements.concat(this.$store.state.vector.extension.standardActivities);
        }

        if(!trigger.item) {
          return `Module: ${trigger.description} ${trigger.id}`;
        }

        var element = allElements.find((x) => x.id == trigger.item);
        if (element) {
          return `${trigger.notification ? "Notification" : "Script"} on ${
            element.name
          }`;
        }
      }

      return "(configuration removed)";
    },
  },
  watch: {
    module: function (newValue, oldValue) {
      this.loadNotificationDashboard();
    },
  },
  async mounted() {
    await this.loadNotificationDashboard();
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.notification-panel {
  .notification-panel-label {
    font-size: 1.5rem;
    font-weight: 600;
  }
  .notification-panel-form-label {
    margin-bottom: .375rem;
    font-size: 1rem;
    color: var(--fts-form-label);
  }
  .notification-panel-form-group {
    margin-bottom: 2rem;
  }
}
</style>